import { useEffect, useState } from 'react';

import { useContainer } from 'unstated-next';

import InviteStudentsRow from '../components/InviteStudentsRow';
import { blankStudent, perPage } from '../constants/inviteStudentsDefaults';
import InviteStudentsContainer from '../InviteStudentsContainer';
import { StyledPagination } from '../styles/styled-components';

const SimpleInvite = () => {
    const {
        canSubmit,
        students,
        setStudents,
        errorIndexes,
        setErrors,
        handleStudentChange,
        isDuplicateEmail,
        isDuplicateExtUserId
    } = useContainer(InviteStudentsContainer);
    const [currentPage, setCurrentPage] = useState(1);

    const numberOfStudents = students.length;
    const numberOfPages = Math.ceil(numberOfStudents / perPage);

    useEffect(() => {
        setErrors(students);
        // eslint-disable-next-line
    }, []);

    const addRow = () => {
        setStudents([...students, { ...blankStudent }]);

        const newPageCreated = Math.ceil((numberOfStudents + 1) / perPage) !== currentPage;
        if (newPageCreated) setCurrentPage(currentPage + 1); // Advance the current page when a new page is created by clicking the "add" button
    };

    const removeRow = (index: number) => {
        const copyOfStudents = [...students];
        copyOfStudents.splice(index, 1);
        setStudents(copyOfStudents);
        setErrors(copyOfStudents);
    };

    const renderRows = () => {
        if (numberOfStudents === 0) {
            return (
                <InviteStudentsRow
                    key={0}
                    index={0}
                    student={blankStudent}
                    addRow={addRow}
                    removeRow={removeRow}
                    handleChange={handleStudentChange}
                    lastRow={true}
                    canSubmit={canSubmit}
                    isDuplicateEmail={false}
                    isDuplicateExtUserId={false}
                />
            );
        }

        // To reduce computational overhead with very large data we compose a set of paginated indexes from which to render the student rows
        const paginatedValidIndexes: number[] = [];
        let currentIndex = (currentPage - 1) * perPage;

        while (paginatedValidIndexes.length < perPage && currentIndex < numberOfStudents) {
            paginatedValidIndexes.push(currentIndex);
            currentIndex += 1;
        }

        return paginatedValidIndexes.map((studentIndex) => {
            const lastRow = studentIndex === numberOfStudents - 1;

            return (
                <InviteStudentsRow
                    key={studentIndex}
                    index={studentIndex}
                    student={students[studentIndex]}
                    addRow={addRow}
                    removeRow={removeRow}
                    handleChange={handleStudentChange}
                    lastRow={lastRow}
                    canSubmit={canSubmit}
                    showErrors={errorIndexes.includes(studentIndex)}
                    isDuplicateEmail={isDuplicateEmail(studentIndex)}
                    isDuplicateExtUserId={isDuplicateExtUserId(studentIndex)}
                />
            );
        });
    };

    return (
        <>
            {renderRows()}

            {numberOfPages > 1 && (
                <StyledPagination
                    count={numberOfPages}
                    page={currentPage}
                    color="primary"
                    onChange={(event, page) => {
                        if (page !== null && page !== undefined) setCurrentPage(page);
                    }}
                />
            )}
        </>
    );
};

export default SimpleInvite;
